import {
  AgreementDocumentType,
  IAgreementItem,
  IAgreementVersion,
} from '../../../../types/interfaces/agreement';

export type AgreementsState = {
  selectedType: AgreementDocumentType;
  selectedVersionId: string | null;
  selectedLanguageKey: string | null;
  isCreateVersionModalOpen: boolean;
  isCreateItemModalOpen: boolean;
  isEditItemModalOpen: boolean;
  isDeleteModalOpen: boolean;
  isPublishConfirmOpen: boolean;
  isArchiveConfirmOpen: boolean;
  isSortModalOpen: boolean;
  itemForEdit: IAgreementItem | null;
  itemForDelete: IAgreementItem | null;
};

export const initialAgreementsState: AgreementsState = {
  selectedType: 'termsOfUse',
  selectedVersionId: null,
  selectedLanguageKey: null,
  isCreateVersionModalOpen: false,
  isCreateItemModalOpen: false,
  isEditItemModalOpen: false,
  isDeleteModalOpen: false,
  isPublishConfirmOpen: false,
  isArchiveConfirmOpen: false,
  isSortModalOpen: false,
  itemForEdit: null,
  itemForDelete: null,
};

type AgreementsAction =
  | { type: 'SET_SELECTED_TYPE'; payload: AgreementDocumentType }
  | { type: 'SET_SELECTED_VERSION'; payload: string | null }
  | { type: 'SET_SELECTED_LANGUAGE'; payload: string | null }
  | { type: 'OPEN_CREATE_VERSION_MODAL' }
  | { type: 'CLOSE_CREATE_VERSION_MODAL' }
  | { type: 'OPEN_CREATE_ITEM_MODAL' }
  | { type: 'CLOSE_CREATE_ITEM_MODAL' }
  | { type: 'OPEN_EDIT_ITEM_MODAL'; payload: IAgreementItem }
  | { type: 'CLOSE_EDIT_ITEM_MODAL' }
  | { type: 'OPEN_DELETE_MODAL'; payload: IAgreementItem }
  | { type: 'CLOSE_DELETE_MODAL' }
  | { type: 'OPEN_PUBLISH_CONFIRM' }
  | { type: 'CLOSE_PUBLISH_CONFIRM' }
  | { type: 'OPEN_ARCHIVE_CONFIRM' }
  | { type: 'CLOSE_ARCHIVE_CONFIRM' }
  | { type: 'OPEN_SORT_MODAL' }
  | { type: 'CLOSE_SORT_MODAL' };

export function agreementsReducer(
  state: AgreementsState,
  action: AgreementsAction,
): AgreementsState {
  switch (action.type) {
    case 'SET_SELECTED_TYPE':
      return {
        ...state,
        selectedType: action.payload,
        selectedVersionId: null,
        isCreateVersionModalOpen: false,
        isCreateItemModalOpen: false,
        isEditItemModalOpen: false,
        isDeleteModalOpen: false,
        isPublishConfirmOpen: false,
        isArchiveConfirmOpen: false,
        isSortModalOpen: false,
        itemForEdit: null,
        itemForDelete: null,
      };
    case 'SET_SELECTED_VERSION':
      return { ...state, selectedVersionId: action.payload };
    case 'SET_SELECTED_LANGUAGE':
      return { ...state, selectedLanguageKey: action.payload };
    case 'OPEN_CREATE_VERSION_MODAL':
      return { ...state, isCreateVersionModalOpen: true };
    case 'CLOSE_CREATE_VERSION_MODAL':
      return { ...state, isCreateVersionModalOpen: false };
    case 'OPEN_CREATE_ITEM_MODAL':
      return { ...state, isCreateItemModalOpen: true };
    case 'CLOSE_CREATE_ITEM_MODAL':
      return { ...state, isCreateItemModalOpen: false };
    case 'OPEN_EDIT_ITEM_MODAL':
      return {
        ...state,
        isEditItemModalOpen: true,
        itemForEdit: action.payload,
      };
    case 'CLOSE_EDIT_ITEM_MODAL':
      return { ...state, isEditItemModalOpen: false, itemForEdit: null };
    case 'OPEN_DELETE_MODAL':
      return {
        ...state,
        isDeleteModalOpen: true,
        itemForDelete: action.payload,
      };
    case 'CLOSE_DELETE_MODAL':
      return { ...state, isDeleteModalOpen: false, itemForDelete: null };
    case 'OPEN_PUBLISH_CONFIRM':
      return { ...state, isPublishConfirmOpen: true };
    case 'CLOSE_PUBLISH_CONFIRM':
      return { ...state, isPublishConfirmOpen: false };
    case 'OPEN_ARCHIVE_CONFIRM':
      return { ...state, isArchiveConfirmOpen: true };
    case 'CLOSE_ARCHIVE_CONFIRM':
      return { ...state, isArchiveConfirmOpen: false };
    case 'OPEN_SORT_MODAL':
      return { ...state, isSortModalOpen: true };
    case 'CLOSE_SORT_MODAL':
      return { ...state, isSortModalOpen: false };
    default:
      return state;
  }
}

export function getSelectedVersion(
  versions: IAgreementVersion[] = [],
  selectedVersionId: string | null,
) {
  if (!versions.length) return null;
  if (selectedVersionId) {
    return versions.find((version) => version.id === selectedVersionId) ?? null;
  }
  return (
    versions.find((version) => version.status === 'published') ?? versions[0]
  );
}
